// dev mode cache work, build prod mode cache not work

// import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
// import { persistQueryClient } from "@tanstack/react-query-persist-client";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
// import localforage from "localforage";

// const { MODE } = import.meta.env;

// const queryClient = new QueryClient({
//   defaultOptions: {
//     queries: {
//       staleTime: 1000 * 60 * 2,
//       cacheTime: 1000 * 60 * 5,
//       refetchOnWindowFocus: true,
//       refetchOnMount: true,
//     },
//   },
// });

// let persister = null;

// if (typeof window !== "undefined") {
//   persister = createAsyncStoragePersister({
//     storage: localforage,
//   });

//   persistQueryClient({
//     queryClient,
//     persister,
//     maxAge: 1000 * 60 * 60 * 24,
//   });
// }

// export function QueryProvider({ children }) {
//   return (
//     <QueryClientProvider client={queryClient}>
//       {children}
//       {MODE === "development" && <ReactQueryDevtools initialIsOpen={false} />}
//     </QueryClientProvider>
//   );
// }

// cache fully working version (dev-prod)

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import { persistQueryClient } from "@tanstack/react-query-persist-client";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import localforage from "localforage";

const { VITE_MODE } = import.meta.env;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 1,
      cacheTime: 1000 * 60 * 3,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
    },
  },
});

let persister = null;

if (typeof window !== "undefined") {
  persister = createAsyncStoragePersister({ storage: localforage });

  persistQueryClient({
    queryClient,
    persister,
    maxAge: 1000 * 60 * 60 * 24,
  });
}

export async function restoreQueryClient() {
  if (persister) {
    await persister.restoreClient(queryClient);
  }
}

export function QueryProvider({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {typeof window !== "undefined" && VITE_MODE === "development" && (
        <ReactQueryDevtools initialIsOpen={false} />
      )}
    </QueryClientProvider>
  );
}

// const persister = {
//     persistClient: async (client) => {
//         await localforage.setItem('SPS_OFFLINE_CACHE', client)
//     },
//     restoreClient: async () => {
//         const data = await localforage.getItem('SPS_OFFLINE_CACHE')
//         return data || undefined
//     },
//     removeClient: async () => {
//         await localforage.removeItem('SPS_OFFLINE_CACHE')
//     },
// }
